import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import React from 'react';
import { Form, OriCheckbox } from 'src/components/Antd';
import AtDiscountValue, {
  DiscountValueType,
} from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import Table from '../ProductQuantity';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const Card = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    directCheckName,
    getDirectCheckName,
    radioName,
    percentageName,
    reductionAmountName,
    currency,
    enableProductName,
    getEnableProductName,
    productTableName,
    getRadioName,
    tableId,
    disableEdit,
  } = props;

  return (
    <React.Fragment>
      <Item name={directCheckName} valuePropName={'checked'}>
        <OriCheckbox className={css.directDiscount} disabled={disableEdit}>
          {getI18n('general.directDiscount')}
        </OriCheckbox>
      </Item>

      <Item
        shouldUpdate={(p, c) => {
          const pv = get(p, getDirectCheckName || directCheckName);
          const cv = get(c, getDirectCheckName || directCheckName);
          return pv !== cv;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = getFieldValue(
            getDirectCheckName || directCheckName,
          );
          if (isDisplay) {
            return (
              <div className={css.directContainer}>
                <AtDiscountValue
                  currency={currency}
                  radioName={radioName}
                  percentageName={percentageName}
                  reductionAmountName={reductionAmountName}
                  getRadioName={getRadioName}
                  options={[
                    DiscountValueType.Percentage,
                    DiscountValueType.Reduction,
                  ]}
                  disableEdit={disableEdit}
                />
              </div>
            );
          }
          return null;
        }}
      </Item>

      <Item name={enableProductName} valuePropName={'checked'}>
        <OriCheckbox className={css.directDiscount} disabled={disableEdit}>
          {getI18n('general.gifts')}
        </OriCheckbox>
      </Item>

      <Item
        shouldUpdate={(p, c) => {
          const pv = get(p, getEnableProductName || enableProductName);
          const cv = get(c, getEnableProductName || enableProductName);
          return pv !== cv;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = getFieldValue(
            getEnableProductName || enableProductName,
          );
          if (isDisplay) {
            return (
              <div className={css.tableContainer}>
                <Item
                  name={productTableName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if ((value || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.advancedFilters.commonRadioMulSelect.selectItem',
                              ),
                            ),
                          );
                        }
                        const flatten = value.reduce((pre, now) => {
                          const { children } = now;
                          if ((children || []).length > 0) {
                            return [...pre, ...children];
                          }
                          return [...pre, now];
                        }, []);
                        const invalid = flatten.filter((i) => !i.quantity);
                        if (invalid.length > 0) {
                          return Promise.reject();
                        }
                      },
                    },
                  ]}>
                  <Table
                    tableId={tableId}
                    disableEdit={disableEdit}
                    currency={currency}
                  />
                </Item>
              </div>
            );
          }
          return null;
        }}
      </Item>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const pv = get(p, getEnableProductName || enableProductName);
          const cv = get(c, getEnableProductName || enableProductName);
          const pv2 = get(p, getDirectCheckName || directCheckName);
          const cv2 = get(c, getDirectCheckName || directCheckName);
          return pv !== cv || pv2 !== cv2;
        }}>
        {({ getFieldValue }) => {
          const t1 = getFieldValue(getDirectCheckName || directCheckName);
          const t2 = getFieldValue(getEnableProductName || enableProductName);
          const isDisplay = !t1 && !t2;
          if (isDisplay) {
            return (
              <div className={css.tip}>
                <Icon type='iconinfo2' className={css.infoIcon} />
                {getI18n('salesChannelSubscriptionBuy.card.tip')}
              </div>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default Card;
